// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19EDH","option":"styles_option__1RNkI","active":"styles_active__GqutR"};